import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetLeadTimeForChangesRangeData = {
  metricsRange: Pick<SpaceliftMetrics, "averageLeadTimeForChangesRange" | "hasRuns">;
};

export const GET_LEAD_TIME_FOR_CHANGES_RANGE: TypedDocumentNode<
  GetLeadTimeForChangesRangeData,
  QueryMetricsRangeArgs
> = gql`
  query GetLeadTimeForChangesRange($input: MetricsInput) {
    metricsRange(input: $input) {
      averageLeadTimeForChangesRange {
        value
        timestamp
      }
      hasRuns
    }
  }
`;
